<template>
  <DelDialog width="1100px" :dialogVisible="visible" :showClose="false" :showButton="true"
    :showConfirmButton="showConfirmButton" @handleClose="handleCancel" @handleConfirm="handleConfirm">
    <template #title>{{ $t('assignTaskV2.watch') }}</template>
    <div class="table">
      <el-table v-if="showTable" border height="100%" :data="previewObj.sentList" header-row-class-name="customHeader"
        v-loading="previewObj.loadingFlag">
        <el-table-column :label="$t('assignTaskV2.sentenceParagraph')" align="center" width="90px">
          <template slot-scope="{ $index }">{{ $index + 1 }}</template>
        </el-table-column>
        <el-table-column :label="$t('assignTaskV2.originallyText')" prop="sourceSent">
        </el-table-column>
        <el-table-column :label="$t('assignTaskV2.text')" prop="targetSent">
        </el-table-column>
      </el-table>
      <div class="task-score" v-else v-loading="loading"><span>{{ content }}</span></div>
    </div>
    <template #confirm>{{ $t('assignTaskV2.reviews') }}</template>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import {
  getEvaluateResult
} from '@/services/assignTaskApi';

export default {
  name: 'Preview',
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
    previewObj: {
      type: Object,
      require: true,
      default() {
        return {
          loadingFlag: false
        }
      }
    },
    showConfirmButton: {
      type: Boolean,
      require: false,
    },
  },
  components: {
    DelDialog
  },
  data() {
    return {
      resObj: {},
      showTable: true,
      loading: true,
      content: '',
    }
  },
  methods: {
    handleCancel() {
      this.resObj = {};
      this.showTable = true;
      this.loading = true;
      this.$emit('handleCancel');
    },
    async handleConfirm() {
      this.loading = true;
      this.showTable = false;
      this.content = '';
      const { success, result } = await getEvaluateResult({
        id: this.previewObj.taskId,
        taskType: this.previewObj.taskType,
      });
      if (!success) {
        return;
      }
      this.loading = false;
      this.resObj = result;
      this.content = `${this.$t('assignTaskV2.accuracyRate')}：${this.resObj.taskScore}%`;
      this.$emit('updateTaskList');
    },
  },
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>